import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SrFeSupplierMgmtModule } from 'projects/sr-fe-supplier-mgmt/src/lib/sr-fe-supplier-mgmt.module';
import { AuthenticationModule, MainLayoutComponent, DashboardModule } from 'sr-fe-core';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => AuthenticationModule
  },
  {
    path: 'supplier-mgmt',
    loadChildren: () => import('../../projects/sr-fe-supplier-mgmt/src/lib/sr-fe-supplier-mgmt.module').then(m => SrFeSupplierMgmtModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
